export function downloadFile(url: string, reportName: string): void {
  const link = document.createElement("a");
  link.href = url;
  link.download = reportName;
  link.click();
}
